import type { Bit, GateType } from './SignalState';

export function evaluateGate(type: GateType, a: Bit, b: Bit): Bit {
  if (type === 'AND') return (a && b) as Bit;
  if (type === 'NAND') return (!Boolean(a && b) ? 1 : 0);
  return (a || b) as Bit;
}

export function inputFromSwitch(closedToGround: boolean): Bit {
  return closedToGround ? 0 : 1;
}

export function ledFromOutput(output: Bit): boolean {
  return output === 0;
}
